import { UserService } from '@teammood/shared/util/user';
import { Team, TeamMemberDialogService } from '@teammood/team';
import { TeamMember } from '../../team-member/team-member.type';
import * as _ from "lodash";
import { takeUntil, tap } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { TeamMemberComponent } from "../team-member/team-member.component";
import { OutOfOffice } from "@teammood/shared/ui/out-of-office";
import { endOfDay, parse, startOfDay, isBefore, isAfter } from "date-fns";
  
@Component({
    selector: 'team-members-list',
    templateUrl: './team-members-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        TeamMemberComponent
    ]
})
export class TeamMembersListComponent implements OnInit {
    isUserAdminOfMultipleTeams: boolean;

    @Input()
    team: Team

    @Input()
    selectionEnabled: boolean

    @Input()
    members: Member[]

    @Input()
    moveEnabled: boolean

    @Output()
    onMemberChanged = new EventEmitter();

    @Output()
    onMemberChecked = new EventEmitter<TeamMember>();

    constructor(
        private userService: UserService,
        private teamMemberDialogService: TeamMemberDialogService
    ){}

    ngOnInit() {
        this.userService.isAdminOfMultipleTeams().then(isAdminOfMultipleTeams => {
            this.isUserAdminOfMultipleTeams = isAdminOfMultipleTeams;
        })
    }

    private pausedUntil(outOfOffices: OutOfOffice[]) {
        const now = new Date();
        return _.find(outOfOffices, (ooo) => {
            const vacationStart = startOfDay(parse(ooo.from, "dd/MM/yyyy", new Date()))
            const vacationEnd = endOfDay(parse(ooo.to, "dd/MM/yyyy", new Date()))
            return isBefore(vacationStart, now) && isAfter(vacationEnd, now);
        });
    }

    check() {
        this.onMemberChecked.emit();
    };

    /** Update Member */
    async editMember(member: TeamMember) {
        const dialogRef = await this.teamMemberDialogService.update(this.team, member);

        dialogRef.componentInstance.onMemberChanged.pipe(
            tap(() => this.onMemberChanged.emit()),
            takeUntil(dialogRef.afterClosed())
        ).subscribe()
    }

    async openMoveModal(team: Team, member: TeamMember) {
        const dialogRef = await this.teamMemberDialogService.move(team, member);

        dialogRef.beforeClosed().pipe(
            tap(() => this.onMemberChanged.emit()),
            takeUntil(dialogRef.afterClosed())
        ).subscribe()
    }

    isMemberActive(member: TeamMember) {
        if(!member.active || this.pausedUntil(member.outOfOffice)){
            return 'disabled-teammember-row';
        }
    }

    hasTags(): boolean {
        if (this.members) {
            return this.members.flatMap(m => m.tags).length > 0;
        } else {
            return false;
        }

    }

}

export interface Member extends TeamMember{
    checked?: boolean
}